import React from 'react'

export default function GameEvents({events}) {
  return <div>
    <div className='text-center'>Total Game Count: {events.length}</div>
    <table className='table table-striped'>
      <thead>
        <tr>
          <th className='col-xs-3'>Time</th>
          <th className='col-xs-3'>Location</th>
        </tr>
      </thead>
      <tbody>
        {
          events.map((event, index) => {
            return <tr key={index}>
              <td>{moment(event.date).format('dddd MM/DD/YYYY [at] LT')}</td>
              <td>{event.location}</td>
            </tr>
          })
        }
      </tbody>
    </table>
  </div>
}
